import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
 
@Injectable()
export class ErrorService {
 
  constructor(
    private router: Router, public sharedService: SharedService
  ) { }
 
  handleError(error: any) {
    if (error.status === 401) {
      this.sharedService.display(false);
      const publicRoutes = ['ihs-interest-form'];
      const currentUrl = this.router.url;
      const isPublicRoute = publicRoutes.some(route => currentUrl.includes(route));
 
      if (!isPublicRoute) {
        this.router.navigate(['']);
      }
    }
  }
}
 